export function headerFunc() {
  // ハンバーガーメニュー実装
  $('.navToggle').on('click', function () {
    $('.navToggle').toggleClass('closeNav');
    $('.headerNav').toggleClass('openNav');
    $('body').toggleClass('menu-open');
  });

  //ナビゲーションをクリックした際のスムーススクロール
  $('#header a').click(function () {
    $('.navToggle').removeClass('closeNav');
    $('.headerNav').removeClass('openNav');
    $('body').removeClass('menu-open');

    // var elmHash = $(this).attr('href'); //hrefの内容を取得
    // var pos = Math.round($(elmHash).offset().top - 120); //headerの高さを引く
    // $('body,html').animate({
    //   scrollTop: pos
    // }, 500); //取得した位置にスクロール※数値が大きいほどゆっくりスクロール
    // return false; //リンクの無効化
  });

  $('.spOnly .headerNav__parent').on('click', function() {
    $(this).next('.headerNav__child').slideToggle();
    $(this).toggleClass('open');
  });

    //言語セレクタ
    $('.lang-sw__current').on('click', function() {
      $(this).next('.lang-sw__list').toggleClass('show');
      $(this).toggleClass('show');
    });
    
}

// var hd_size = $('#header').innerHeight();
// var pos = 0;

export function headerScrFunc() {
  // var headerH = $('#header').outerHeight(true);
  // var headerHharth = headerH / 2;
  // var scroll = $(window).scrollTop();
  // if (scroll >= headerHharth && scroll < headerH) {
  //   $('#header').addClass('hidden');
  // } else if(scroll >= headerH) {
  //   $('#header').removeClass('hidden');
  //   $('#header').addClass('fixed');
  // } else { //それ以外は
  //   $('#header').removeClass('fixed');
  //   $('#header').removeClass('hidden');
  // }
}